<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper">
    <div class="behaviour-card-sec">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{ feedbackDetails.student.firstName }}
          {{ feedbackDetails.student.lastName }}
        </h3>
        <div class="cta-wrapper">
          <button
            nz-button
            type="button"
            nz-button
            nzType="default"
            (click)="openExportManagerDialog()"
            aria-label="export feedback for student">
            <svg-icon
              src="/assets/icon/icon-export-share.svg"
              aria-label="Export Share"></svg-icon>
            <span class="text s-14">Export Manager</span>
          </button>
          <button
            *ngIf="setOfCheckedOrgId.length > 0"
            nz-button
            type="button"
            nz-button
            nzType="default"
            (click)="showExportDetailDialog()"
            aria-label="export feedback for student">
            <svg-icon
              src="/assets/icon/icon-printer.svg"
              aria-label="Printer"></svg-icon>
            <span class="text s-14"
              >Export ({{ setOfCheckedOrgId.length }})</span
            >
          </button>
          <button
            nz-button
            type="button"
            nz-button
            nzType="primary"
            (click)="submitFeedback()"
            aria-label="Submit feedback for student">
            Submit Feedback
          </button>
        </div>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"
              aria-label="Calendar"></svg-icon>
            {{ feedbackDetails.student.dateOfBirth | date: 'MM/dd/yyyy' }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"
              aria-label="Supervisor"></svg-icon>
            {{ feedbackDetails.supervisorName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-18"
              aria-label="Male"></svg-icon>
            {{ feedbackDetails.student.gender }}
          </p>
        </div>
      </div>
    </div>
    <nz-divider />
    <!-- Feedback History Table -->
    <nz-table
      #sortTable
      nzShowSizeChanger
      [nzData]="(feedBackHistory$ | async)?.result?.items ?? []"
      [nzFrontPagination]="false"
      [nzTotal]="(feedBackHistory$ | async)?.result?.totalRows || 0"
      [(nzPageIndex)]="pageIndex"
      [nzPageSize]="pageSize"
      (nzQueryParams)="onQueryParamsChange($event)"
      [nzScroll]="{ x: '1200', y: 'calc(100vh - 354px)' }"
      (nzCurrentPageDataChange)="onCurrentPageDataChange($event)">
      <thead>
        <tr>
          <th
            *ngIf="sortTable.data.length > 0; else emptySelectionHeader"
            scope="col"
            nzWidth="30px"
            [nzSelections]="listOfSelection"
            [(nzChecked)]="checkedOrganization"
            [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)"></th>
          <ng-template #emptySelectionHeader>
            <th scope="col" nzWidth="30px"></th>
          </ng-template>
          <th
            scope="col"
            nzWidth="400px"
            [nzSortFn]="true"
            [title]="listOfColumn[0].title"
            [nzColumnKey]="listOfColumn[0].key">
            {{ listOfColumn[0].title }}
          </th>
          <th
            scope="col"
            nzWidth="250px"
            [nzSortFn]="true"
            [title]="listOfColumn[1].title"
            [nzColumnKey]="listOfColumn[1].key">
            {{ listOfColumn[1].title }}
          </th>
          <th
            scope="col"
            nzWidth="170px"
            [nzSortFn]="true"
            [title]="listOfColumn[2].title"
            [nzColumnKey]="listOfColumn[2].key">
            {{ listOfColumn[2].title }}
          </th>
          <th scope="col" nzWidth="150px"></th>
          <th scope="col" nzWidth="135px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of sortTable.data">
          <td
            [nzChecked]="setOfCheckedOrgId.includes(item.id)"
            [nzDisabled]="!item.isAllQuestionsFeedbackSubmitted"
            (nzCheckedChange)="onItemChecked(item.id, $event)"></td>
          <td>
            {{ item.caseMemberUserFirstName }} {{ item.caseMemberUserLastName }}
          </td>
          <td>{{ item.createdDate | userDate: 'MM/dd/yyyy hh:mm a' }}</td>
          <td>
            {{ item.isAllQuestionsFeedbackSubmitted ? item.overallScore : '-' }}
          </td>
          <td>
            <button
              type="button"
              nz-button
              nzType="default"
              (click)="fetchAdminNotes(item)">
              Notes
            </button>
          </td>
          <td>
            <div class="action-btn-wrapper">
              <button
                nz-button
                [title]="'Resume Feedback'"
                nzType="text"
                *ngIf="
                  !item.isAllQuestionsFeedbackSubmitted &&
                  isFeedBackEditable &&
                  loggedInUserId === item.caseMemberUserId
                "
                (click)="viewFeedback(item, insightMode.RESUME)">
                <svg-icon
                  src="/assets/icon/icon-resume.svg"
                  class="icon s-20"
                  aria-label="Resume"></svg-icon>
              </button>
              <button
                nz-button
                [title]="'Edit Feedback'"
                nzType="text"
                *ngIf="
                  item.isAllQuestionsFeedbackSubmitted &&
                  isFeedBackEditable &&
                  loggedInUserId === item.caseMemberUserId
                "
                (click)="viewFeedback(item, insightMode.EDIT)">
                <svg-icon
                  src="/assets/icon/icon-edit.svg"
                  class="icon s-20"
                  aria-label="Edit"></svg-icon>
              </button>
              <button
                nz-button
                nzType="text"
                [title]="'View Feedback'"
                *ngIf="item.isAllQuestionsFeedbackSubmitted"
                (click)="viewFeedback(item)">
                <svg-icon
                  src="/assets/icon/icon-eye.svg"
                  class="icon s-20"
                  aria-label="Eye"></svg-icon>
              </button>
              <button
                *ngIf="item.isAllQuestionsFeedbackSubmitted"
                type="button"
                [nzLoading]="isPrintLoadingForItem(item.id) | async"
                nz-button
                [title]="'Download Feedback Report'"
                nzType="text"
                (click)="showAdminNote(item)">
                <svg-icon
                  src="/assets/icon/icon-download.svg"
                  class="icon s-20"
                  aria-label="Download">
                </svg-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #viewFeedbackFormTpl>
      <app-drawer-header
        [title]="'Feedback'"
        subtitle="Feedback"
        [breadcrumbText]="feedbackDetails.student.firstName || ''"
        (drawerClose)="closeFeedBackFormDrawer()">
      </app-drawer-header>
    </ng-template>
  </div>
</nz-spin>
<nz-modal
  [(nzVisible)]="isModalVisible"
  [nzTitle]="modalHeaderTemplate"
  (nzOnCancel)="handleModalClose()"
  nzWidth="1000px"
  [nzClassName]="'small-header-height'">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <h3 class="ant-modal-title">Report Filter</h3>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <form nz-form class="form" [formGroup]="printForm">
      <div class="drawer-form-wrapper feedback-print-modal">
        <app-graph-filter
          (filterChange)="onFilterChange($event)"></app-graph-filter>
      </div>
    </form>
  </ng-container>

  <div *nzModalFooter>
    <div class="modal-footer">
      <button nz-button nzType="default" (click)="handleModalClose()">
        Close
      </button>
      <button
        nz-button
        nzType="primary"
        [disabled]="
          printForm.invalid ||
          (isPrintLoadingForItem(selectedFeedback?.id || 0) | async)
        "
        [nzLoading]="isPrintLoadingForItem(selectedFeedback?.id || 0) | async"
        (click)="printFeedback()">
        Download
      </button>
    </div>
  </div>
</nz-modal>

<nz-modal
  [(nzVisible)]="isAdminNotesModalVisible"
  [nzTitle]="adminNotesModalTitle"
  (nzOnCancel)="handleModalClose()"
  [nzFooter]="null"
  nzWidth="600px"
  [nzClassName]="'small-header-height admin-note-modal'">
  <ng-template #adminNotesModalTitle>
    <div class="modal-header">
      <span class="ant-modal-title">Notes</span>
      <button
        nz-button
        nzType="default"
        class="primary-outlined modal-header-btn"
        (click)="openNoteModal()">
        {{ editingNote ? 'Edit My Note' : 'Add Note' }}
      </button>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="(loading$ | async) ?? false">
      <div class="content-wrapper">
        <ng-container *ngIf="notes && notes.length > 0; else noNotes">
          <div class="data-wrapper">
            <div class="data" *ngFor="let note of notes">
              <p class="note-text">{{ note.comment }}</p>
              <span class="note-author">- {{ note.userName }}</span>
            </div>
          </div>
        </ng-container>
        <ng-template #noNotes>
          <p class="no-data-text">No Note Available</p>
        </ng-template>
      </div>
    </nz-spin>
  </ng-container>
</nz-modal>

<nz-modal
  [nzVisible]="isNoteModalVisible"
  [nzTitle]="editingNote ? 'Edit Note' : 'Add Note'"
  [nzFooter]="noteFooter"
  nzWidth="600px"
  [nzClassName]="'small-header-height'"
  (nzOnCancel)="handleModalClose()">
  <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="isNoteSubmitting">
      <form nz-form [formGroup]="noteForm" nzLayout="vertical">
        <nz-form-item>
          <nz-form-label nzFor="note" nzRequired>Note</nz-form-label>
          <nz-form-control [nzErrorTip]="noteErrorTpl">
            <textarea
              nz-input
              formControlName="comment"
              id="note"
              placeholder="Enter note"
              [nzAutosize]="{ minRows: 4, maxRows: 8 }">
            </textarea>
            <div
              class="mt-3 remaining-text"
              *ngIf="noteForm.get('comment')?.value">
              {{ noteForm.get('comment')?.value.length || 0 }} of 2000
              characters used
            </div>
            <ng-template #noteErrorTpl let-control>
              <ng-container *ngIf="control.hasError('required')">
                Please enter note
              </ng-container>
              <ng-container *ngIf="control.hasError('maxlength')">
                Note cannot exceed 2000 characters.
              </ng-container>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </form>
    </nz-spin>
  </ng-container>
  <ng-template #noteFooter>
    <div class="modal-footer">
      <button nz-button nzType="default" (click)="handleModalClose()">
        Cancel
      </button>
      <button
        nz-button
        nzType="primary"
        [nzLoading]="isNoteSubmitting"
        [disabled]="noteForm.invalid || isNoteSubmitting"
        (click)="saveNote()">
        Submit
      </button>
    </div>
  </ng-template>
</nz-modal>
<app-confirm-dialog
  class="progress-report-model"
  [isVisible]="isShowExportDetailDialog"
  title="Feedback Report Detail"
  message=""
  width="950px"
  [cancelText]="'Cancel'"
  [disableConfirm]="reportDetailForm && !reportDetailForm.valid"
  (cancelled)="handleExportDetailClose()"
  (closed)="handleExportDetailClose()"
  (confirmed)="handleExportDetailConfirm()"
  [messageTemplate]="exportDetailTemplate"
  [primaryButtonClass]="'btn btn-primary'"
  [confirmText]="'Submit'">
</app-confirm-dialog>
<ng-template #exportDetailTemplate>
  <div class="drawer-form-wrapper mt-2">
    <app-graph-filter
      (filterChange)="onExportFilterChange($event)"></app-graph-filter>
    <form
      nz-form
      class="form mt-16"
      nzLayout="horizontal"
      [formGroup]="reportDetailForm">
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="reportTitle"
          >Report Title</nz-form-label
        >
        <nz-form-control [nzErrorTip]="reportTitleErrorTpl">
          <input
            nz-input
            id="reportTitle"
            formControlName="reportTitle"
            placeholder="Enter title" />
          <ng-template #reportTitleErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please enter title
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="reportDescription" [nzRequired]="true"
          >Description</nz-form-label
        >
        <nz-form-control [nzErrorTip]="reportDescriptionErrorTpl">
          <textarea
            id="reportDescription"
            formControlName="reportDescription"
            rows="4"
            nz-input
            placeholder="Add description"></textarea>
          <ng-template #reportDescriptionErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please enter description
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              Description cannot exceed 2000 characters.
            </ng-container>
          </ng-template>

          <div class="mt-3 remaining-text">
            {{ reportDetailForm.value?.reportDescription?.length || 0 }} of 2000
            characters used
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
</ng-template>

<app-confirm-dialog
  [isVisible]="isShowExportManagerDialog"
  title="Export Manager"
  message=""
  width="1000px"
  (closed)="handleExportManagerClose()"
  (cancelled)="handleExportManagerClose()"
  [messageTemplate]="exportManagerTemplate"
  [footerTemplate]="exportManagerFooter">
</app-confirm-dialog>
<ng-template #exportManagerTemplate>
  <div class="export-manager-content">
    <nz-table
      #sortTable
      [nzData]="exportedReports"
      [nzFrontPagination]="false"
      [nzLoading]="loading$ | async"
      [nzTotal]="reportTotal || 0"
      [(nzPageIndex)]="reportPageIndex"
      [nzPageSize]="reportPageSize"
      (nzQueryParams)="onCurrentReportPageDataChange($event)">
      <thead>
        <tr>
          <th
            scope="col"
            nzWidth="210px"
            [nzColumnKey]="'title'"
            [nzSortFn]="true">
            Report Title
          </th>
          <th
            scope="col"
            nzWidth="240px"
            [nzColumnKey]="'description'"
            [nzSortFn]="true">
            Description
          </th>
          <th
            scope="col"
            nzWidth="100px"
            [nzColumnKey]="'status'"
            [nzSortFn]="true">
            Status
          </th>
          <th scope="col" nzWidth="250px" [nzShowSort]="false">Download</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let report of sortTable.data">
          <td [title]="report.title">{{ report.title }}</td>
          <td [title]="report.description">
            {{ report.description || '-' }}
          </td>
          <td>
            <div class="status" [ngClass]="getJobStatusClass(report.statusId)">
              <span>{{ getJobStatusText(report.statusId) }}</span>
            </div>
          </td>
          <td nzAlign="left">
            <button
              *ngIf="
                report.statusId === JobStatusEnum.Success ||
                report.statusId === JobStatusEnum.PartiallySuccess
              "
              nz-button
              nzType="text"
              class="action-btn"
              (click)="downloadReport(report)">
              <svg-icon
                src="/assets/icon/icon-report-download.svg"
                class="icon s-16"
                aria-label="Report Download"></svg-icon>
            </button>
            <span *ngIf="report.statusId === JobStatusEnum.Pending">
              Processing
            </span>
            <span
              *ngIf="report.statusId === JobStatusEnum.Fail"
              class="error-message"
              title="Failed due to some technical issue">
              Failed due to some technical issue
            </span>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</ng-template>
<ng-template #exportManagerFooter>
  <div class="modal-footer">
    <button nz-button nzType="default" (click)="handleExportManagerClose()">
      Close
    </button>
  </div>
</ng-template>
